{
  "administrationSetup": {
    "competences": {
      "template": {
        "description": "Starte mit einer verwandten Vorlage (anderer Kanton oder benachbarte Schulform) und passe sie an."
      }
    }
  },
  "classes": {
    "addSchoolSubjectFromOtherLevels": "Kompetenzen aus anderen Klassenstufen hinzufügen",
    "bumpUpClassSelectModeDescription": "Willst du eine neue Klasse erstellen, oder eine Klasse hochstufen?",
    "bumpUpDescription": "Stufe eine bestehende Klasse in die nächste Klassenstufe hoch. Schülerinnen und Schüler, sowie Zugriffsrechte werden übernommen.",
    "generalDataDescription": "Lass uns eine neue Klasse erstellen. Bitte lege Klassenstufe und Name fest.",
    "newSchoolLevel": "Neue Klassenstufe"
  },
  "errorMessages": {
    "TENANT_NOT_CONNECTED_TO_STATE": "Deiner Schule ist noch kein Kanton zugeordnet. Er kann in den Schuleinstellungen ergänzt werden."
  },
  "general": {
    "schoolLevel": "Klassenstufe",
    "schoolLevelCount": "1 Klassenstufe | {count} Klassenstufen",
    "schoolLevelOption": "Klassenstufe { schoolLevel }",
    "schoolLevelsContinuousHint": "Klassenstufen müssen zusammenhängend sein — keine Lücken erlaubt (z. B. 1–6)."
  },
  "gradeCalculation": {
    "schoolLevels": {
      "dialogDescription": "Für welche Klassenstufen soll die Notenempfehlung verwendet werden?",
      "dialogTitle": "Klassenstufen",
      "scopeAll": "alle Klassenstufen",
      "scopeMultiple": "Klassenstufen {schoolLevels}",
      "scopePreSchoolAndMultiple": "die Vorschulstufe sowie Klassenstufen {schoolLevels}",
      "scopePreSchoolAndSingle": "die Vorschulstufe sowie Klassenstufe {schoolLevel}",
      "scopeSingle": "Klassenstufe {schoolLevel}"
    }
  },
  "groups": {
    "levelAndGroup": "Klassenstufe / Gruppe",
    "tipAdmin": "Hier kannst du Gruppen erstellen und verwalten. In Gruppen kannst du Schüler:innen klassen- und jahrgangsübergreifend zusammenfassen – zum Beispiel für Förder-, Chor- oder Leistungsgruppen."
  },
  "schoolSubject": {
    "schoolLevel": "Klassenstufe",
    "allSchoolLevels": "Alle Klassenstufen"
  },
  "externalMaterial": {
    "schoolLevels": "Klassenstufen"
  },
  "onboarding": {
    "class": {
      "schoolLevel": "Klassenstufe"
    },
    "schoolLevels": {
      "edit": "Klassenstufen bearbeiten",
      "editConfirmDescription": "Bitte gib deinen Vor- und Nachnamen oder deine E-Mail-Adresse ein, um die Klassenstufen zu bearbeiten.",
      "editConfirmHint": "Die entfernten Klassenstufen werden auch aus den Kompetenzvorlagen deiner Schule entfernt. Bestehende Klassen sind davon nicht betroffen.",
      "editDescription": "Welche Klassenstufen umfasst deine Schule?",
      "title": "Bitte wähle nun die Klassenstufen für deine “{schoolTypeName}”."
    },
    "schoolSubject": {
      "title": "Super, wir haben für dich schon mal alle Kompetenzen für Klassenstufe {schoolLevel} vorbereitet."
    }
  },
  "performanceAssessment": {
    "hint": "Hier legst du fest, wie die Leistungen in den einzelnen Klassenstufen und Semestern dokumentiert werden sollen. Für die Kompetenzerfassung steht dir bereits eine Vorlage zur Verfügung."
  },
  "reports": {
    "competencesSchoolLevel": "Kompetenzen Klassenstufe {schoolLevel}",
    "hideInputValues": "Textfelder von Hand ausfüllen",
    "level": "Klassenstufe {schoolLevel}",
    "levelAndClass": "Klassenstufe / Klasse"
  },
  "schoolSubjects": {
    "confirm": {
      "descriptionDifferentSchoolType": "Du hast Fächer aus Klassenstufe {sourceGrade} ({sourceSchoolType}) ausgewählt. Möchtest du sie wirklich in die {targetLabel} deiner Schule importieren?"
    },
    "filter": "Klassenstufe { schoolLevel }",
    "filteredEmptyStateDescription": "Für die ausgewählte Klassenstufe wurden keine Fächer gefunden.",
    "filteredEmptyStateTitle": "Keine Fächer für diese Klassenstufe",
    "fromTemplateHelpTextClass": "Fehlt dir ein Förderschwerpunkt, Freifach usw.? Bitte <a class=\"underline hover:no-underline\" href=\"{ mailto }\">kontaktiere deine Schulleitung.</a>",
    "fromTemplateHelpTextMailBody": "Hallo { firstNameReceiver },\n\nbitte erstelle mir diese Kompetenz:\n\nBeste Grüsse,\n{ firstNameSender }\n\n----\nPS: Als Digidoo Administration findest du alle verfügbaren Kompetenzvorlagen (z. B. Förderschwerpunkte, Freifächer, Religionen usw.) unter Schuladministration -> Kompetenzraster -> Hinzufügen. Diese können den Klassen direkt freigeschaltet werden und anschliessend von der Lehrperson importiert werden.\n",
    "tipAdmin": "Hier siehst du alle Kompetenzen aller Klassenstufen. Du kannst Fächer, Kompetenzbereiche und einzelne Kompetenzen bearbeiten, neu anlegen oder aus einer Vorlage hinzufügen. Diese Kompetenzen dienen als schulweite Vorlage und können – je nach Zugriffsrechten – von Lehrpersonen in den Klassen bearbeitet oder übernommen werden."
  },
  "schoolYears": {
    "emptyStateMailBody": "Hallo Digidoo-Team,\n\nfür diese Schule fehlt ein Schuljahr.\n\nSchule: {schoolName}\nKanton: {state}\nSchul-ID: {schoolId}\nAnsprechperson: {userName}\nE-Mail: {userEmail}\n\nBitte ergänzt das fehlende Schuljahr.\n\nVielen Dank!"
  },
  "templateSet": {
    "importDialog": {
      "hint": "Fehlt dir ein Kanton oder hast du weitere Ideen oder Feedback?"
    },
    "upload": {
      "hiddenSchoolLevels": "Der gewählte Schultyp hat die Klassenstufen {levels} aus der Datei nicht. Deren Fächer werden nicht angezeigt.",
      "noMatchingSchoolLevels": "Die Datei enthält nur Fächer der Klassenstufen {fileLevels}, der gewählte Schultyp hat die Klassenstufen {schoolTypeLevels}. Bitte wähle einen passenden Schultyp.",
      "schoolLevelsMismatch": "Die Datei enthält keine Fächer für die Klassenstufen des gewählten Schultyps."
    }
  },
  "tenants": {
    "changeSchoolTypeConfirm": {
      "hint": "Bestehende Klassenstufen, Klassen, Fächer und Bewertungen bleiben unverändert. Künftig verfügbare Lehrplan- und Fachvorlagen richten sich nach dem neuen Schultyp."
    }
  },
  "performanceAssessmentCatalog": {
    "homework": "Hausaufgabe",
    "oral-exercise": "Mündlicher Beitrag",
    "written-exam": "Prüfung"
  },
  "supportMeasureEntry": {
    "materials": {
      "otherSchoolLevel": "Andere Klassenstufe"
    }
  }
}
